import classNames from 'classnames'

import { Tags } from 'components/Tags'
import { Badge } from 'components/ui/Badge/Badge'
import { EmptyContainer } from 'services/warehouse-containers/containers'

export type Props = {
  element: EmptyContainer
  onClick?: (element: EmptyContainer) => void
  highlight?: boolean
}

export const EmptyContainerItem = ({ element, onClick, highlight }: Props) => {
  const handleOnClick = () => {
    onClick?.(element)
  }

  const classnames = classNames('transfer-page-list-item cursor--pointer', {
    'is-highlighted': highlight,
  })

  return (
    <div className={classnames} onClick={handleOnClick}>
      <div className="transfer-page-list-item__header">
        <div>
          <h3 className="transfer-page-list-item__header-title">{element.name}</h3>
          <Badge text={element.labelNumber} badgeStyle="default" />
          <span style={{ padding: '0 2px' }}></span>
          {element.labelled ? <Badge text="Есть QR" badgeStyle="blue" /> : null}
        </div>
        <div className="transfer-page-list-item__header-tags">
          <Tags tags={[element.deliveryType]}></Tags>
        </div>
      </div>
      <div className="transfer-page-list-item__body-containers" style={{ marginTop: '10px' }}>
        <span className="transfer-page-list-item__comment hint font--x-small">{element.id}</span>
      </div>
    </div>
  )
}
